import { classNames, React, observer, computed } from '@api'
import { ListItem, ListItemSecondaryAction, ListItemText, ListItemIcon } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import CheckIcon from '@material-ui/icons/Check';
import { IMappedCatalogItemData, useCatalogItemsListStore } from './'
import * as css from './CatalogItemsToggleListItem.css'
import { PrimaryIconButton } from 'centric-ui-components'

export const CatalogItemsToggleListItem = observer<{ className?: string, data?: IMappedCatalogItemData }>(
  function CatalogItemsToggleListItem({ className,  data: { _id, title, ...data } }) {
  const { toggleListItem, props: { selectedValues }, catalogField } = useCatalogItemsListStore(),
    isSelected = selectedValues.has(_id) || selectedValues.has(title)

  return (
    <ListItem
      data-selected={isSelected == true}
      className={classNames(css.root, className)}
      classes={{ container: css.itemContainer }}
      onClick={!isSelected ? toggleListItem(data, isSelected) : undefined}
      selected={isSelected}
    >
      <ListItemText
        classes={{ primary: classNames(css.listItemName, isSelected && css.disabledText) }}
        primary={title}
        primaryTypographyProps={{ title }}
        disableTypography={isSelected}
        defaultChecked={isSelected}
      />

      {isSelected &&
        <PrimaryIconButton
          icon={catalogField?.def?.type == 'Enum' ? <CheckIcon fontSize="small" /> : <Cancel className={css.cancelIcon} />}
          className={css.linkCSS}
          onClick={toggleListItem(data, isSelected)}
        />}
    </ListItem>
  )
})


// WEBPACK FOOTER //
// ./src/modules/catalog/sidebar/CatalogItemsList/CatalogItemsToggleListItem.tsx